import * as React from 'react';

function SvgMessageStroke1(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.131 22.33l.073-.063c.143-.125.451-.396.56-.478.364-.277.702-.41 1.099-.31.82.184 1.651.308 2.483.372-1.284-1.087-2.079-2.567-2.079-4.216 0-3.394 3.388-6.067 7.477-6.067 1.702 0 3.28.465 4.542 1.254-1.049-3.078-4.664-5.395-8.991-5.395-5.15 0-9.278 3.284-9.285 7.218a6.646 6.646 0 003.37 5.589c.73.453.893 1.222.664 2.065l-.039.134.126-.103zm15.959-7.88c-.138-4.761-4.965-8.523-10.795-8.523-5.913 0-10.776 3.87-10.784 8.738a8.141 8.141 0 004.101 6.858c.04.025.058.111-.015.383-.053.194-.15.418-.279.651-.135.245-.27.444-.352.551a.75.75 0 00.448 1.192c1.035.207 1.84-.115 2.681-.82l.163-.142c.152-.133.357-.312.413-.355a.036.036 0 00.01-.009c1.2.259 2.403.4 3.613.424.574 0 1.136-.035 1.693-.105.849.273 1.773.422 2.736.422.8-.014 1.585-.102 2.356-.26l.168.145h.001c.06.053.114.099.136.117.62.513 1.23.754 2.013.597a.75.75 0 00.446-1.194 2.853 2.853 0 01-.214-.334 1.792 1.792 0 01-.165-.38c-.005-.02-.01-.033-.015-.038a5.675 5.675 0 002.75-4.704c0-1.189-.407-2.287-1.11-3.215zm-14.496 8.506l.017.002h.005a1.037 1.037 0 01-.034-.005l-.067-.015c.025.007.048.011.067.015l.012.003zm12.001-1.826a4.178 4.178 0 002.105-3.488c0-2.483-2.634-4.574-5.956-4.574-3.328 0-5.977 2.09-5.977 4.567 0 2.484 2.636 4.58 5.942 4.58.761-.014 1.519-.105 2.25-.268.367-.089.651.025.948.249l.039.03c.017-.435.213-.825.65-1.096z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgMessageStroke1;
